import { DocumentBulkUploadResult } from 'mapistry-shared';
import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateSiteDocumentsCache,
  SiteDocumentsCacheEvents,
} from '@monorepo/shared/cacheRegisters/documents/siteDocumentsCacheRegister';
import { MutationConfig, useMutation } from 'react-query';

type UseUploadSiteDocumentsParams = {
  config?: MutationConfig<DocumentBulkUploadResult, Api.ErrorResponse>;
};

export const useUploadSiteDocuments = (params?: UseUploadSiteDocumentsParams) =>
  useMutation(Api.uploadProjectDocuments, {
    ...params?.config,
    onSuccess: (data, vars) => {
      invalidateSiteDocumentsCache(SiteDocumentsCacheEvents.CREATE, {
        organizationId: vars.organizationId,
        projectId: vars.projectId,
        folderId: vars.folderId,
      });
      return params?.config?.onSuccess?.(data, vars);
    },
  });
